import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type {
  ReleaseScheduleSourceEnum,
  ReleaseScheduleStatusEnum,
} from '@/lib/api-admin/types';

export type ReleaseSort =
  | 'releaseAt,asc'
  | 'releaseAt,desc'
  | 'createdAt,desc'
  | 'createdAt,asc';

export const RELEASE_SORT_VALUES: ReadonlyArray<ReleaseSort> = [
  'releaseAt,asc',
  'releaseAt,desc',
  'createdAt,desc',
  'createdAt,asc',
];

export interface ReleaseScheduleFiltersState {
  keyword: string;
  vendorId: string | null;
  artistId: string | null;
  status: ReadonlyArray<ReleaseScheduleStatusEnum>;
  source: ReleaseScheduleSourceEnum | null;
  from: string | null;
  to: string | null;
  page: number;
  size: number;
  sort: ReleaseSort;
  setKeyword: (v: string) => void;
  setVendorId: (v: string | null) => void;
  setArtistId: (v: string | null) => void;
  setStatuses: (v: ReadonlyArray<ReleaseScheduleStatusEnum>) => void;
  setSource: (v: ReleaseScheduleSourceEnum | null) => void;
  setFrom: (v: string | null) => void;
  setTo: (v: string | null) => void;
  setPage: (v: number) => void;
  setSize: (v: number) => void;
  setSort: (v: ReleaseSort) => void;
  reset: () => void;
}

const INITIAL = {
  keyword: '',
  vendorId: null as string | null,
  artistId: null as string | null,
  status: [] as ReadonlyArray<ReleaseScheduleStatusEnum>,
  source: null as ReleaseScheduleSourceEnum | null,
  from: null as string | null,
  to: null as string | null,
  page: 1,
  size: 20,
  sort: 'releaseAt,asc' as ReleaseSort,
};

export const useReleaseScheduleFiltersStore = create<ReleaseScheduleFiltersState>()(
  devtools(
    (set) => ({
      ...INITIAL,
      setKeyword: (keyword) => set({ keyword, page: 1 }),
      setVendorId: (vendorId) => set({ vendorId, page: 1 }),
      setArtistId: (artistId) => set({ artistId, page: 1 }),
      setStatuses: (status) => set({ status, page: 1 }),
      setSource: (source) => set({ source, page: 1 }),
      setFrom: (from) => set({ from, page: 1 }),
      setTo: (to) => set({ to, page: 1 }),
      setPage: (page) => set({ page }),
      setSize: (size) => set({ size, page: 1 }),
      setSort: (sort) => set({ sort, page: 1 }),
      reset: () => set({ ...INITIAL }),
    }),
    { name: 'release-schedule-filters' },
  ),
);
